import { RootState } from "@mds/common/redux/rootState";
import * as actionTypes from "@mds/common/constants/actionTypes";
import { ACTIVITIES } from "@mds/common/constants/reducerTypes";
import { IActivity } from "@mds/common/interfaces/activity";

interface IActivityReducer {
  activities: IActivity[];
  totalActivities: number;
}

const initialState: IActivityReducer = {
  activities: [],
  totalActivities: null,
};

export const activityReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.STORE_ACTIVITIES:
      return {
        ...state,
        activities: action.payload.records,
        totalActivities: action.payload.total,
      };
    case actionTypes.CLEAR:
      return {
        activities: [],
        totalActivities: null,
      };
    default:
      return state;
  }
};

const activityReducerObject = {
  [ACTIVITIES]: activityReducer,
};

export const getActivities = (state: RootState) => state[ACTIVITIES].activities;
export const getTotalActivities = (state: RootState) => state[ACTIVITIES].totalActivities;

export default activityReducerObject;
